import React, { useState } from "react";
import { Alert, Button } from "@amzn/awsui-components-react";
import { Investigation, Stage } from "../../lusca-search-api/generated-src";
import { TakeOwnershipModal } from "./TakeOwnershipModal";
import { isTerminal } from "./investigationUtils";

interface InvestigationOwnerBannerProps {
  stage: Stage;
  investigation: Investigation;
  onError: (message: string) => void;
}

/**
 * Warning shown above everything else on an ownerless, unresolved investigation.
 * Nobody is accountable for it until someone takes ownership, so the fix is one click away.
 * Renders nothing when the case has an owner or is resolved (resolved cases are locked anyway).
 */
export const InvestigationOwnerBanner: React.FC<
  InvestigationOwnerBannerProps
> = ({ stage, investigation, onError }) => {
  const [claimVisible, setClaimVisible] = useState(false);
  if (investigation.owner || isTerminal(investigation.status)) {
    return null;
  }
  return (
    <>
      <Alert
        type="warning"
        header="This investigation needs an owner"
        action={
          <Button onClick={() => setClaimVisible(true)}>Take ownership</Button>
        }
      >
        Nobody is accountable for it right now: comments can be added, but its
        status cannot change until someone owns it.
      </Alert>
      <TakeOwnershipModal
        stage={stage}
        investigation={investigation}
        visible={claimVisible}
        onDismiss={() => setClaimVisible(false)}
        onError={onError}
      />
    </>
  );
};

export default InvestigationOwnerBanner;
